import { MSafeAny } from '@mercadona/common/private';

/**
 * Transforms a given date or today date by default to a locale ISO format including timezone
 *
 * @param {Date} date The date to be transformed.
 * @returns {string} The the formatted date as string.
 */
export function toLocalISO(date = new Date()): string {
  const tzo = -date.getTimezoneOffset(); // en minutos
  const sign = tzo >= 0 ? '+' : '-';

  const pad = (num: MSafeAny, size = 2) => String(Math.abs(Math.floor(num))).padStart(size, '0');

  return (
    date.getFullYear() +
    '-' +
    pad(date.getMonth() + 1) +
    '-' +
    pad(date.getDate()) +
    'T' +
    pad(date.getHours()) +
    ':' +
    pad(date.getMinutes()) +
    ':' +
    pad(date.getSeconds()) +
    '.' +
    pad(date.getMilliseconds(), 3) +
    sign +
    pad(tzo / 60) +
    ':' +
    pad(tzo % 60)
  );
}
